import { Component, OnInit } from '@angular/core';
import { File} from '../../../_models/file';
import * as fromFile from '../../../file/state/file.reducer';
import * as fileActions from '../../../file/state/file.actions';
import * as fromRoot from '../../../state/app.reducer';
import * as rootActions from '../../../state/app.actions';
import { Store, select } from '@ngrx/store';
// import { takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './file-edit-shell.component.html'
})

export class FileEditShellComponent implements OnInit {

    // errorMessage$: Observable<string>;
    file$: Observable<File>;
    infoList$: Observable<any>;
    fileList$: Observable<File[]>;

  constructor(
    private storeRoot: Store<fromRoot.State>,
    private store: Store<fromFile.State>
  ) {}

  ngOnInit() {

    this.file$ = this.store.pipe(select(fromFile.getCurrentFile)) as Observable<File>;

    this.infoList$ = this.store.pipe(select(fromFile.getInfoList)) as Observable<any>;

    // Se obtienen los...
    this.fileList$ = this.store.pipe(select(fromFile.getFileList)) as Observable<File[]>;

  }

  saveFile(fileIn: File): void {

    console.log('---> saveFile fileIn:');
    console.log(fileIn);

    if (fileIn.id === null) {
      console.log('Se va a CREAR un nuevo vidrio.');
      this.store.dispatch( new fileActions.CreateFile(fileIn));
    } else {
      console.log('Se va a MODIFICAR un vidrio existente.');
      this.store.dispatch( new fileActions.UpdateFile(fileIn));
    }
  }

  updateFile(fileIn: any): void {

    console.log('---> updateFile fileIn:');
    // console.log(fileFileIn);

    if (fileIn !== null) {
      console.log('Se va a CARGAR un fichero.');
      this.store.dispatch( new fileActions.UpdateFile(fileIn));
    } else {
      console.log('No existen datos de fichero para cargar.');
    }
  }

  optimizerFile(fileIn: any): void {

    console.log('---> optimizerFile fileIn:');
    console.log(fileIn);

    if (fileIn !== null) {
      console.log('Se va a OPTIMIZAR un fichero.');
      this.store.dispatch( new fileActions.OptimizerFile(fileIn));
    } else {
      console.log('No existen datos de fichero para optimizar.');
    }
  }


  // --------------------------------------------------------------
  // Función para mostrar la ventana genérica de información.
  showInfoModal(modalParams) {

    console.log('---->>>>.... Ejecutando prodData-edit-shell showInfoModal: '
    + modalParams.value + ' ;Info: ' + modalParams.info + ' ;Link: ' + modalParams.link + ' ;Skin: ' + modalParams.skin);

    this.storeRoot.dispatch( new rootActions.ChangeInfoModal({
      value: modalParams.value,
      info: modalParams.info,
      link: modalParams.link,
      param: modalParams.param,
      skin: modalParams.skin
    }));

  } // End function showInfoModal


} // End class FileEditShellComponent
